import React from 'react';
import { ImageProps } from '.';

const SvgZexpressEmblem = ({ size = 51, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 4.25)) || 12} fill='none' viewBox='0 0 51 12' {...props}>
      <path
        fill='#6E52FF'
        d='M22.708 10.736H21.38V8.434h-5.168V7.367h6.496v3.369ZM40.928 10.736h-1.265V5.933h-.851v4.363h-1.256V1.35h1.256v3.495h.85v-3.63h1.267v9.52Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M46.007 7.346c2.055 0 3.279.617 3.29 1.705-.011 1.088-1.235 1.685-3.29 1.685-2.075 0-3.31-.597-3.31-1.685s1.235-1.705 3.31-1.705Zm0 1.015c-1.317 0-1.971.22-1.96.69-.011.471.643.69 1.96.69 1.287 0 1.95-.219 1.961-.69-.01-.47-.674-.69-1.96-.69Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M26.687 9.501h5.24v1.067h-6.578V7.482h1.338v2.02ZM7.788 1.56c2.74-.044 4.962 1.7 4.962 4.286l-.007.239c-.133 2.452-2.3 4.088-4.955 4.045a5.213 5.213 0 0 1-1.449-.225C4.612 9.419 1.213 7.347.058 6.485c-.118-.088-.041-.264.107-.25l6.956.673c.106.01.168.118.116.207l-.67 1.157c-.074.128.081.264.211.186l4.046-2.436a.204.204 0 0 0 0-.354L6.778 3.232c-.13-.077-.285.059-.21.187l.669 1.157c.05.088-.01.196-.116.206l-6.956.673c-.148.015-.224-.162-.107-.249 1.155-.862 4.554-2.936 6.281-3.422a5.212 5.212 0 0 1 1.45-.224Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M34.257 4.207h1.286V2.062h1.225v6.414h-3.756V2.062h1.245v2.145Zm0 3.201h1.286V5.253h-1.286v2.155Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M31.678 8.11H30.35V1.225h1.328V8.11ZM29.354 2.962h-1.9v.136c0 1.14.696 2.302 2.252 2.772l-.674 1.047c-1.058-.335-1.805-1.02-2.23-1.884a3.818 3.818 0 0 1-2.304 2.062l-.685-1.047c1.567-.512 2.293-1.747 2.293-2.95v-.136h-1.94V1.894h5.188v1.068ZM22.708 6.948H21.38V1.214h1.328v5.734ZM46.66 5.755h3.664v1.068h-8.612V5.755h3.641V4.583h1.308v1.172ZM20.383 2.836h-1.898c.01 1.114.705 2.286 2.251 2.752l-.674 1.036c-1.059-.33-1.806-1.015-2.231-1.884a3.803 3.803 0 0 1-2.304 2.062l-.684-1.036c1.556-.508 2.282-1.742 2.293-2.93h-1.94V1.77h5.187v1.067Z'
      />
      <path
        fill='#6E52FF'
        d='M46.682 1.685c0 1.11 1.058 2.166 3.185 2.428l-.508 1.035c-1.593-.24-2.766-.915-3.362-1.872-.607.957-1.78 1.637-3.372 1.872l-.467-1.035c2.085-.262 3.175-1.35 3.175-2.428v-.314h1.349v.314Z'
      />
    </svg>
  );
};

export default SvgZexpressEmblem;
